const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.TrackOpticsVideoServiceSimpleClient =
  function TrackOpticsVideoServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.listTrackOpticsVideos = this.listTrackOpticsVideos.bind(this);
    this.getTrackOpticsVideo = this.getTrackOpticsVideo.bind(this);
    this.submitTrackOpticsVideo = this.submitTrackOpticsVideo.bind(this);
    this.pullTrackOpticsVideoConditions =
      this.pullTrackOpticsVideoConditions.bind(this);
    this.pullTrackOpticsVideoFileSignedUrl =
      this.pullTrackOpticsVideoFileSignedUrl.bind(this);
    this.handleTrackOpticsVideoPubsub =
      this.handleTrackOpticsVideoPubsub.bind(this);
  };
const methodInfo_TrackOpticsVideoService_ListTrackOpticsVideos =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/ListTrackOpticsVideos",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest,
    imports.stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse.decode
  );
module.exports.TrackOpticsVideoServiceSimpleClient.prototype.listTrackOpticsVideos =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/ListTrackOpticsVideos",
      message,
      metadata || {},
      methodInfo_TrackOpticsVideoService_ListTrackOpticsVideos
    );
  };
const methodInfo_TrackOpticsVideoService_GetTrackOpticsVideo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/GetTrackOpticsVideo",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest,
    imports.stronachgroup.first.racehorse360.TrackOpticsVideo,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.TrackOpticsVideo.decode
  );
module.exports.TrackOpticsVideoServiceSimpleClient.prototype.getTrackOpticsVideo =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/GetTrackOpticsVideo",
      message,
      metadata || {},
      methodInfo_TrackOpticsVideoService_GetTrackOpticsVideo
    );
  };
const methodInfo_TrackOpticsVideoService_SubmitTrackOpticsVideo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/SubmitTrackOpticsVideo",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest,
    imports.stronachgroup.first.racehorse360.TrackOpticsVideo,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.TrackOpticsVideo.decode
  );
module.exports.TrackOpticsVideoServiceSimpleClient.prototype.submitTrackOpticsVideo =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/SubmitTrackOpticsVideo",
      message,
      metadata || {},
      methodInfo_TrackOpticsVideoService_SubmitTrackOpticsVideo
    );
  };
const methodInfo_TrackOpticsVideoService_PullTrackOpticsVideoConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/PullTrackOpticsVideoConditions",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest,
    imports.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse.decode
  );
module.exports.TrackOpticsVideoServiceSimpleClient.prototype.pullTrackOpticsVideoConditions =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/PullTrackOpticsVideoConditions",
      message,
      metadata || {},
      methodInfo_TrackOpticsVideoService_PullTrackOpticsVideoConditions
    );
  };
const methodInfo_TrackOpticsVideoService_PullTrackOpticsVideoFileSignedUrl =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/PullTrackOpticsVideoFileSignedUrl",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest,
    imports.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse.decode
  );
module.exports.TrackOpticsVideoServiceSimpleClient.prototype.pullTrackOpticsVideoFileSignedUrl =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/PullTrackOpticsVideoFileSignedUrl",
      message,
      metadata || {},
      methodInfo_TrackOpticsVideoService_PullTrackOpticsVideoFileSignedUrl
    );
  };
const methodInfo_TrackOpticsVideoService_HandleTrackOpticsVideoPubsub =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/HandleTrackOpticsVideoPubsub",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.TrackOpticsVideoServiceSimpleClient.prototype.handleTrackOpticsVideoPubsub =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/HandleTrackOpticsVideoPubsub",
      message,
      metadata || {},
      methodInfo_TrackOpticsVideoService_HandleTrackOpticsVideoPubsub
    );
  };
